<template>
  <div class="view-register auth pb-5">
    <div class="container">
      <router-link
        class="btn btn-outline-light btn-strong login-link d-none d-lg-block"
        :to="{ name: 'login' }"
      >
        Entrar
      </router-link>

      <h3 class="text-center py-5 text-light" v-if="errorMessage">
        {{ errorMessage }}
      </h3>

      <action-dispatcher
        class="text-light"
        action="user/validateToken"
        :parameters="$route.params.token"
        @success="successToken"
        @error="errorToken"
      >
        <div class="row">
          <div class="col-md-6 col-lg-5 mx-auto">
            <div class="px-5">
              <h1 class="text-center p-5">
                <img class="img-fluid" src="../assets/logo.png" />
              </h1>
            </div>

            <form
              class="card bg-dark border-0 text-light"
              @submit.prevent="submit"
            >
              <div class="card-body">
                <h3 class="text-center">Cadastre-se</h3>
                <p class="text-center mb-4">
                  Você foi convidado por {{ indiquer }}
                </p>

                <form-group
                  v-model="form.name"
                  id="name"
                  type="text"
                  placeholder="Seu nome"
                  :errors="errors.name"
                />

                <form-group
                  v-model="form.email"
                  id="email"
                  type="email"
                  placeholder="Seu e-mail"
                  :errors="errors.email"
                />

                <form-group
                  v-model="form.password"
                  id="password"
                  type="password"
                  placeholder="Escolha uma senha"
                  :errors="errors.password"
                />

                <b-form-checkbox
                  id="terms"
                  v-model="terms"
                  name="terms"
                  :value="true"
                >
                  <small>
                    Declaro que li e concordo com os
                    <router-link :to="{ name: 'terms' }">
                      <strong>
                        Termos de uso
                      </strong>
                    </router-link>
                  </small>
                </b-form-checkbox>

                <div class="text-center py-3">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block btn-strong"
                    :disabled="!terms || loading"
                  >
                    <loading :show="loading">Cadastrar</loading>
                  </button>
                </div>

                <div class="text-center d-lg-none pb-3">
                  <router-link
                    class="btn btn-outline-light btn-strong btn-block"
                    :to="{ name: 'login' }"
                  >
                    Entrar
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import get from "lodash/get";

export default {
  name: "register",
  data() {
    return {
      indiquer: "",
      errorMessage: null,
      terms: false,
      loading: false,
      ...formFields(["name", "email", "password"])
    };
  },
  methods: {
    successToken(response) {
      this.indiquer = get(response, "data.name");
      this.errorMessage = null;
    },
    errorToken(error) {
      this.errorMessage = get(error, "response.data.message");
    },
    submit() {
      this.$message.hide();

      this.loading = true;

      this.$store
        .dispatch("user/register", {
          ...this.form,
          token: this.$route.params.token
        })
        .then(() => {
          this.$router.replace({ name: "home" });
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-register {
  width: 100%;

  .login-link {
    position: absolute;
    top: 80px;
    right: 80px;
  }

  @media screen and (max-width: 991px) {
    .card {
      background: transparent !important;
    }

    ::v-deep .form-control {
      border: 1px solid #535353;
    }
  }
}
</style>
